import { Box, Chip, MenuItem, Select } from "@mui/material";
import React from "react";
import PropTypes from 'prop-types';
const PortInputs = ({
  modules,
  style,
  options,
  locationType,
  selectedValue,
  setSelectedValue,
  disabled,
}) => {
  const handleDelete = (value) => {
    setSelectedValue(selectedValue.filter((item) => item !== value));
  };
  return (
    <Select
      style={{ ...style }}
      multiple
      disabled={disabled}
      renderValue={(selected) => (
        <Box
          sx={{ display: "flex", gap: 0.5, overflow: "scroll" }}
          className="noScrollBar"
        >
          {selected.map((value, index) => (
            <Chip
              key={value}
              onMouseDown={(event) => {
                event.stopPropagation();
              }}
              color="error"
              onDelete={() => !disabled && handleDelete(value)}
              sx={{
                borderRadius: "4px",
                "& .MuiChip-label": {
                  color: "white",
                  fontWeight: "bold",
                },
              }}
              label={value}
            ></Chip>
          ))}
        </Box>
      )}
      value={selectedValue}
      onChange={(e) => setSelectedValue(e.target.value)}
    >
      {options.map((item, index) => (
        <MenuItem key={index+""} value={item}>
         {item}
        </MenuItem>
      ))}
    </Select>
  );
};
PortInputs.propTypes = {
  modules: PropTypes.any,
  style: PropTypes.any,
  options: PropTypes.any,
  locationType: PropTypes.any,
  selectedValue: PropTypes.any,
  setSelectedValue: PropTypes.any,
  disabled: PropTypes.any,
};
export default PortInputs;
